const Const:any = {
    linentech:process.env.REACT_APP_LINENTECH_URL,
    linenconnect:process.env.REACT_APP_LINEN_CONNECT_URL,
    linenIq:process.env.REACT_APP_LINENIQ_URL,
    apiUrl:process.env.REACT_APP_API_URL,
    equipmate:process.env.REACT_APP_EQUIMATE_URL,
    linendesk:process.env.REACT_APP_LINENDESK_URL,
    linencrew:process.env.REACT_APP_LINENCREW_URL,
    // Logout (not login) endpoint of the connected app. Portal sign-out sends
    // the browser here so the app's session on THIS device ends too — a
    // server-to-server call could only log the user out on every device.
    linentechLogout:process.env.REACT_APP_LINENTECH_LOGOUT_URL,
    linendeskLogout:process.env.REACT_APP_LINENDESK_LOGOUT_URL,
    linencrewLogout:process.env.REACT_APP_LINENCREW_LOGOUT_URL
};

export default Const;